import axios from 'axios';
import {checkErrors} from './errors';

export const LOADKIOSKS_REQUESTED = 'kiosks/LOADKIOSKS_REQUESTED';
export const LOADKIOSKS_FINISHED = 'kiosks/LOADKIOSKS_FINISHED';
export const SETKIOSKS = 'kiosks/SETKIOSKS';

export const ADDKIOSK_REQUESTED = 'kiosks/ADDKIOSK_REQUESTED';
export const ADDKIOSK_FINISHED = 'kiosks/ADDKIOSK_FINISHED';

export const EDITKIOSK_REQUESTED = 'kiosks/EDITKIOSK_REQUESTED';
export const EDITKIOSK_FINISHED = 'kiosks/EDITKIOSK_FINISHED';

export const REMOVEKIOSK_REQUESTED = 'kiosks/REMOVEKIOSK_REQUESTED';
export const REMOVEKIOSK = 'kiosks/REMOVEKIOSK';
export const REMOVEKIOSK_FINISHED = 'kiosks/REMOVEKIOSK_FINISHED';

export const LOADKIOSK_REQUESTED = 'kiosks/LOADKIOSK_REQUESTED';
export const LOADKIOSK_FINISHED = 'kiosks/LOADKIOSK_FINISHED';

export const LOADKIOSKSASSIGNMENTS_REQUESTED = 'kiosks/LOADKIOSKSASSIGNMENTS_REQUESTED';
export const LOADKIOSKSASSIGNMENTS_FINISHED = 'kiosks/LOADKIOSKSASSIGNMENTS_FINISHED';
export const SETKIOSKSASSIGNMENTS = 'kiosks/SETKIOSKSASSIGNMENTS';

export const ADDKIOSKSASSIGNMENTS_REQUESTED = 'kiosks/ADDKIOSKSASSIGNMENTS_REQUESTED';
export const ADDKIOSKSASSIGNMENTS_FINISHED = 'kiosks/ADDKIOSKSASSIGNMENTS_FINISHED';

export const EDITKIOSKSASSIGNMENTS_REQUESTED = 'kiosks/EDITKIOSKSASSIGNMENTS_REQUESTED';
export const EDITKIOSKSASSIGNMENTS_FINISHED = 'kiosks/EDITKIOSKSASSIGNMENTS_FINISHED';

export const REMOVEKIOSKASSIGNMENT_REQUESTED = 'kiosks/REMOVEKIOSKASSIGNMENT_REQUESTED';
export const REMOVEKIOSKASSIGNMENT_FINISHED = 'kiosks/REMOVEKIOSKASSIGNMENT_FINISHED';

const initialState = {
  kiosks: [],
  total: 0,
  limit: 1000,
  skip: 0,
  isLoadingKiosks: false,
  isAddingKiosk: false,
  isEditingKiosk: false,
  isRemovingKiosk: false,
  isLoadingKiosk: false,
  kiosksassignments: [],
  isLoadingKiosksAssignments: false,
  isAddingKiosksAssignments: false,
  isEditingKiosksAssignments: false,
  isRemovingKiosksAssignments: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOADKIOSKS_REQUESTED:
    return {
      ...state,
      isLoadingKiosks: true
    };

  case LOADKIOSKS_FINISHED:
    return {
      ...state,
      isLoadingKiosks: false
    };

  case SETKIOSKS:
    
    return {
      ...state,
      kiosks: action.kiosks
    };

  case ADDKIOSK_REQUESTED:
    return {
      ...state,
      isAddingKiosk: true
    };

  case ADDKIOSK_FINISHED:
    return {
      ...state,
      isAddingKiosk: false
    };
  
  case EDITKIOSK_REQUESTED:
    return {
      ...state,
      isEditingKiosk: true
    };

  case EDITKIOSK_FINISHED:
    return {
      ...state,
      isEditingKiosk: false
    };

  case REMOVEKIOSK:
    return {
      ...state,
      kiosks: action.kiosks
    };

  case REMOVEKIOSK_REQUESTED:
    return {
      ...state,
      isRemovingKiosk: true,
    };

  case REMOVEKIOSK_FINISHED:
    return {
      ...state,
      isRemovingKiosk: false
    };
  
  case LOADKIOSK_REQUESTED:
    return {
      ...state,
      isLoadingKiosk: true
    };

  case LOADKIOSK_FINISHED:
    return {
      ...state,
      isLoadingKiosk: false
    };

  case LOADKIOSKSASSIGNMENTS_REQUESTED:
    return {
      ...state,
      isLoadingKiosksAssignments: true
    };

  case LOADKIOSKSASSIGNMENTS_FINISHED:
    return {
      ...state,
      isLoadingKiosksAssignments: false
    };

  case SETKIOSKSASSIGNMENTS:
    
    return {
      ...state,
      kiosksassignments: action.kiosksassignments
    };

  case ADDKIOSKSASSIGNMENTS_REQUESTED:
    return {
      ...state,
      isAddingKiosksAssignments: true
    };

  case ADDKIOSKSASSIGNMENTS_FINISHED:
    return {
      ...state,
      isAddingKiosksAssignments: false
    };

  case EDITKIOSKSASSIGNMENTS_REQUESTED:
    return {
      ...state,
      isEditingKiosksAssignments: true
    };

  case EDITKIOSKSASSIGNMENTS_FINISHED:
    return {
      ...state,
      isEditingKiosksAssignments: false
    };

  case REMOVEKIOSKASSIGNMENT_REQUESTED:
    return {
      ...state,
      isRemovingKiosksAssignments: true
    };

  case REMOVEKIOSKASSIGNMENT_FINISHED:
    return {
      ...state,
      isRemovingKiosksAssignments: false
    };

  default:
    return state;
  }
};


export const loadKiosks = () => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADKIOSKS_REQUESTED
    });

    axios.get(`${window.endpoint}/kiosks`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      
      dispatch({
        type: SETKIOSKS,
        kiosks: response.data.kiosks
      });
      
      dispatch({
        type: LOADKIOSKS_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addKiosk = (data, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: ADDKIOSK_REQUESTED
    });

    axios.post(`${window.endpoint}/kiosks`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: ADDKIOSK_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editKiosk = (id, data, cb) => {

  return (dispatch, getState) => {
    

    dispatch({
      type: EDITKIOSK_REQUESTED
    });

    axios.post(`${window.endpoint}/kiosks/${id}`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: EDITKIOSK_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeKiosk = (id, cb) => {
  return (dispatch, getState) => {

    const kiosksState = getState().kiosks;

    dispatch({
      type: REMOVEKIOSK_FINISHED
    });

    axios.delete(`${window.endpoint}/kiosks/${id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVEKIOSK,
        kiosks: kiosksState.kiosks.filter((kiosk) => kiosk.kiosk_id !== id)
      });
      
      dispatch({
        type: REMOVEKIOSK_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadKiosk = (kiosk_id, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADKIOSK_REQUESTED
    });

    axios.get(`${window.endpoint}/kiosks/${kiosk_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: LOADKIOSK_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};


export const loadKiosksAssignments = (cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADKIOSKSASSIGNMENTS_REQUESTED
    });

    axios.get(`${window.endpoint}/kioskassignments`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      
      dispatch({
        type: SETKIOSKSASSIGNMENTS,
        kiosksassignments: response.data.kioskassignments
      });

      dispatch({
        type: LOADKIOSKSASSIGNMENTS_FINISHED
      });

      if (cb instanceof Function) { cb(); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addKiosksAssignments = ({kiosk_id, coordinate_x, coordinate_y, floor_plan_id}, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: ADDKIOSKSASSIGNMENTS_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ kiosk_id, coordinate_x, coordinate_y, floor_plan_id, pointofview: 0, is_active: 1 }));

    axios.post(`${window.endpoint}/kioskassignments`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      if (cb instanceof Function) { cb(); }
      
      dispatch({
        type: ADDKIOSKSASSIGNMENTS_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editKiosksAssignments = (id, {coordinate_x, coordinate_y, pointofview, floor_plan_id, room_name, kiosk_id}, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: EDITKIOSKSASSIGNMENTS_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ coordinate_x, coordinate_y, is_active: 1, pointofview, floor_plan_id, room_name, kiosk_id}));

    axios.post(`${window.endpoint}/kioskassignments/${id}`, formData, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      if (cb instanceof Function) { cb(); }
      
      dispatch({
        type: EDITKIOSKSASSIGNMENTS_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeKioskAssignment = (kioskAssignmentID, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: REMOVEKIOSKASSIGNMENT_REQUESTED
    });

    // should be kioskassignments
    axios.delete(`${window.endpoint}/amenitiesassignments/${kioskAssignmentID}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      if (cb instanceof Function) { cb(); }
      
      dispatch({
        type: REMOVEKIOSKASSIGNMENT_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
}


// WEBPACK FOOTER //
// ./src/reducers/kiosks.js